import PropTypes from "prop-types";
import React, { useState } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { Controller, useController } from "react-hook-form";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/mobile.css";
import classNames from "classnames";

const digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

const DatePickerInput = ({
    label,
    control,
    placeholder,
    rules,
    name,
    message,
    full,
    defaultValue,
    setDate,

    ...rest
}) => {
    // const {
    //     field: { onChange, value },
    //     fieldState: { error },
    // } = useController({
    //     name,
    //     control,
    //     rules,
    //     defaultValue: new DateObject(defaultValue).convert(),
    // });

    return (
        <div className={classNames({ "w-full": full })}>
            {/* <Controller
                control={control}
                name="birthDate"
                render={({ field: { onChange, value15 } }) => ( */}
            <DatePicker
                required
                inputClass="form-control input__field date__picker"
                className="rmdp-mobile"
                format="HH:mm:ss YYYY/MM/DD"
                containerClassName="date__picker--wrapper"
                calendar={persian}
                digits={digits}
                locale={persian_fa}
                placeholder={placeholder}
                mobileLabels={{
                    OK: "تایید ",
                    CANCEL: "انصراف",
                }}
                onChange={(e) => {
                    setDate(e.format());
                }}
                {...rest}
                value={defaultValue}
            />
        </div>
    );
};

// {error && <span className="input__message">{message}</span>}
DatePickerInput.propTypes = {
    control: PropTypes.any,
    label: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    message: PropTypes.string,
};

export default DatePickerInput;
